export class SearchProductparam {
    public ProdSegmentId : number
    public ProdSegmentDesc? : String
    public ProductGroupId: number
    public ProductGroupDesc? : String
    public ProductCode: String
    constructor(
        ) {
            this.ProdSegmentId=0;
            this.ProductGroupId=0;
            this.ProductCode="";
        }
}
